import { IProfile } from '../interfaces/profile.interface';

export const insertProfileToListByIndex = (profilesOriginal: IProfile[], profileToInsert: IProfile, index: number): IProfile[] => {
  const profiles = [...profilesOriginal];
  profiles.splice(index, 0, profileToInsert);

  return profiles;
};
